// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg width=%279px%27 height=%276px%27 viewBox=%270 0 9 6%27 version=%271.1%27 xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27><g id=%27Artboard%27 stroke=%27none%27 stroke-width=%271%27 fill=%27none%27 fill-rule=%27evenodd%27 transform=%27translate%28-636.000000, -171.000000%29%27 fill-opacity=%270.368716033%27><g id=%27input%27 transform=%27translate%28172.000000, 37.000000%29%27 fill=%27%230E242F%27 fill-rule=%27nonzero%27><g id=%27Group-9%27 transform=%27translate%28323.000000, 127.000000%29%27><path d=%27M142.280245,7.23952813 C141.987305,6.92353472 141.512432,6.92361662 141.219585,7.23971106 C140.926739,7.5558055 140.926815,8.06821394 141.219755,8.38420735 L145.498801,13 L149.780245,8.38162071 C150.073185,8.0656273 150.073261,7.55321886 149.780415,7.23712442 C149.487568,6.92102998 149.012695,6.92094808 148.719755,7.23694149 L145.498801,10.7113732 L142.280245,7.23952813 Z%27 id=%27arrow%27></path></g></g></g></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rdrCalendarWrapper {
  color: #000000;
  font-size: 12px;
}

.rdrDateDisplayWrapper {
  background-color: rgb(239, 242, 247);
}

.rdrDateDisplay {
  margin: 0.833em;
}

.rdrDateDisplayItem {
  border-radius: 4px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 1px 2px 0 rgba(35, 57, 66, 0.21);
  border: 1px solid transparent;
}
.rdrDateDisplayItem input {
  cursor: pointer;
  height: 2.5em;
  line-height: 2.5em;
  border: 0px;
  background: transparent;
  width: 100%;
  color: #849095;
}

.rdrDateDisplayItemActive {
  border-color: currentColor;
}

.rdrDateDisplayItemActive input {
  color: #7d888d;
}

.rdrMonthAndYearWrapper {
  align-items: center;
  padding-top: 19px;
  padding-bottom: 15px;
}

.rdrMonthAndYearPickers {
  font-weight: 600;
}
.rdrMonthAndYearPickers select {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  background: transparent;
  padding-right: 30px;
  outline: 0;
  color: #3e484f;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-position: right 8px center;
  cursor: pointer;
  text-align: center;
}
.rdrMonthAndYearPickers select:hover {
  background-color: rgba(0, 0, 0, 0.07);
}

.rdrMonthPicker,
.rdrYearPicker {
  margin: 0 5px;
}

.rdrNextPrevButton {
  width: 24px;
  display: flex;
  justify-content: center;
  background: #ffffff;
  border: 0;
  position: absolute;
}

.rdrNextPrevButtonIconContainer {
  height: 24px;
}

.rdrMonth .rdrWeekDays {
  padding: 0;
}

.rdrMonths.rdrMonthsVertical .rdrMonth:first-child .rdrMonthName {
  display: none;
}

.rdrWeekDay {
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #253342;
}

.rdrWeekEnd {
  opacity: 0.3;
}

.rdrDay {
  background: transparent;
  -webkit-user-select: none;
          user-select: none;
  border: 0;
  padding: 0;
  line-height: 30px;
  height: 30px;
  text-align: center;
  color: #000000;
}
.rdrDay:focus {
  outline: 0;
}

.rdrStartEdge.rdrEndEdge .rdrStartEdgeTriangle {
  color: transparent;
}
.rdrStartEdge.rdrEndEdge .rdrEndEdgeTriangle {
  color: transparent;
}

.rdrDayNumber {
  outline: 0;
  font-weight: 400;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rdrDayToday .rdrDayNumber span {
  font-weight: 500;
}
.rdrDayToday .rdrDayNumber span:after {
  content: "";
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 18px;
  height: 2px;
  border-radius: 2px;
  background: #116E5F;
}

.rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span:after,
.rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span:after {
  background: #fff;
}

.rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
.rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
.rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
.rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
  color: #000000;
}

.rdrSelected,
.rdrInRange,
.rdrStartEdge,
.rdrEndEdge {
  background: currentColor;
  position: absolute;
  top: 2px;
  left: 0;
  right: 0;
  bottom: 2px;
}

.rdrSelected {
  left: 2px;
  right: 2px;
}

.rdrInRange {
  background: #eef6f4;
}

.rdrStartEdge {
  border-radius: 2px;
  left: 2px;
}

.rdrStartEdgeTriangle {
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  bottom: 0;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid currentColor;
  z-index: 1;
}

.rdrEndEdgeTriangle {
  position: absolute;
  left: -2px;
  top: 50%;
  color: #eef6f4;
  transform: translateY(-50%);
  bottom: 0;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid currentColor;
  z-index: 1;
}

.rdrEndEdge {
  border-radius: 2px;
  right: 2px;
}

.rdrSelected {
  border-radius: 2px;
}

.rdrDayStartOfMonth .rdrInRange,
.rdrDayStartOfMonth .rdrEndEdge,
.rdrDayStartOfWeek .rdrInRange,
.rdrDayStartOfWeek .rdrEndEdge {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  left: 2px;
}

.rdrDayEndOfMonth .rdrInRange,
.rdrDayEndOfMonth .rdrStartEdge,
.rdrDayEndOfWeek .rdrInRange,
.rdrDayEndOfWeek .rdrStartEdge {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  right: 2px;
}

.rdrDayStartOfMonth .rdrDayInPreview,
.rdrDayStartOfMonth .rdrDayEndPreview,
.rdrDayStartOfWeek .rdrDayInPreview,
.rdrDayStartOfWeek .rdrDayEndPreview {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  border-left-width: 1px;
  left: 0px;
}

.rdrDayEndOfMonth .rdrDayInPreview,
.rdrDayEndOfMonth .rdrDayStartPreview,
.rdrDayEndOfWeek .rdrDayInPreview,
.rdrDayEndOfWeek .rdrDayStartPreview {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-right-width: 1px;
  right: 0px;
}

.rdrDayStartPreview,
.rdrDayInPreview,
.rdrDayEndPreview {
  background: rgba(255, 255, 255, 0.09);
  position: absolute;
  top: 3px;
  left: 0;
  right: 0;
  bottom: 3px;
  pointer-events: none;
  border: 0px solid currentColor;
  z-index: 1;
}

.rdrDayStartPreview {
  border-top-width: 1px;
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  left: 0px;
}

.rdrDayInPreview {
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.rdrDayEndPreview {
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  right: 2px;
  right: 0px;
}

.rdrDefinedRangesWrapper .rdrStaticRangeSelected {
  color: currentColor;
  font-weight: 600;
}

.rdrStaticRange {
  border: 0;
  cursor: pointer;
  display: block;
  outline: 0;
  border-bottom: 1px solid #eff2f7;
  padding: 0;
  background: #fff;
}
.rdrStaticRange:hover .rdrStaticRangeLabel, .rdrStaticRange:focus .rdrStaticRangeLabel {
  background: #eff2f7;
}

.rdrStaticRangeLabel {
  display: block;
  outline: 0;
  line-height: 18px;
  padding: 10px 20px;
  text-align: left;
}

.rdrInputRange {
  align-items: center;
  padding: 5px 20px;
}

.rdrInputRangeInput {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  text-align: center;
  border: solid 1px rgb(222, 231, 235);
  margin-right: 10px;
  color: rgb(108, 118, 122);
}
.rdrInputRangeInput:focus, .rdrInputRangeInput:hover {
  border-color: rgb(180, 191, 196);
  outline: 0;
  color: #333;
}

.rdrCalendarWrapper:not(.rdrDateRangeWrapper) .rdrDayHovered .rdrDayNumber:after {
  content: "";
  border: 1px solid currentColor;
  border-radius: 2px;
  background: transparent;
}

.rdrDayPassive {
  pointer-events: none;
}
.rdrDayPassive .rdrDayNumber span {
  color: transparent;
}
.rdrDayPassive .rdrInRange,
.rdrDayPassive .rdrStartEdge,
.rdrDayPassive .rdrEndEdge,
.rdrDayPassive .rdrSelected,
.rdrDayPassive .rdrDayStartPreview,
.rdrDayPassive .rdrDayInPreview,
.rdrDayPassive .rdrDayEndPreview {
  display: none;
}

.rdrDayDisabled {
  background-color: rgb(248, 248, 248);
}
.rdrDayDisabled .rdrDayNumber span {
  color: #aeb9bf;
}
.rdrDayDisabled .rdrInRange,
.rdrDayDisabled .rdrStartEdge,
.rdrDayDisabled .rdrEndEdge,
.rdrDayDisabled .rdrSelected,
.rdrDayDisabled .rdrDayStartPreview,
.rdrDayDisabled .rdrDayInPreview,
.rdrDayDisabled .rdrDayEndPreview {
  filter: grayscale(100%) opacity(60%);
}

.rdrMonthName {
  font-size: 14px;
  font-weight: 500;
  color: #116E5F;
}`, "",{"version":3,"sources":["webpack://./src/components/DateRangePicker/theme.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;AACJ;;AAEA;EACI,oCAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,oCAAA;EACA,8CAAA;EACA,6BAAA;AACJ;AACI;EACI,eAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AACR;;AAGA;EACI,0BAAA;AAAJ;;AAII;EACI,cAAA;AADR;;AAKA;EACI,mBAAA;EACA,iBAAA;EACA,oBAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;AAII;EACI,gBAAA;EACA,wBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,6DAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;AAFR;AAIQ;EACI,qCAAA;AAFZ;;AAOA;;EAEI,aAAA;AAJJ;;AAOA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ;;AAUI;EACI,UAAA;AAPR;;AAWA;EACI,aAAA;AARJ;;AAWA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AARJ;;AAWA;EACI,YAAA;AARJ;;AAWA;EACI,uBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AARJ;AAUI;EACI,UAAA;AARR;;AAaI;EACI,kBAAA;AAVR;AAaI;EACI,kBAAA;AAXR;;AAiBA;EACI,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAdJ;;AAiBA;EACI,gBAAA;AAdJ;AAgBI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAdR;;AAsBQ;;EACI,gBAAA;AAlBZ;;AA8BY;;;;EACI,cAAA;AAxBhB;;AA8BA;;;;EAII,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AA3BJ;;AA8BA;EACI,SAAA;EACA,UAAA;AA3BJ;;AA8BA;EACI,mBAAA;AA3BJ;;AA8BA;EACI,kBAAA;EACA,SAAA;AA3BJ;;AA8BA;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;EACA,mCAAA;EACA,UAAA;AA3BJ;;AA8BA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;EACA,2BAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;EACA,mCAAA;EACA,UAAA;AA3BJ;;AA8BA;EACI,kBAAA;EACA,UAAA;AA3BJ;;AA8BA;EACI,kBAAA;AA3BJ;;AAiCI;;;;EAEI,2BAAA;EACA,8BAAA;EACA,SAAA;AA5BR;;AAmCI;;;;EAEI,4BAAA;EACA,+BAAA;EACA,UAAA;AA9BR;;AAqCI;;;;EAEI,2BAAA;EACA,8BAAA;EACA,sBAAA;EACA,SAAA;AAhCR;;AAuCI;;;;EAEI,4BAAA;EACA,+BAAA;EACA,uBAAA;EACA,UAAA;AAlCR;;AAuCA;;;EAGI,qCAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EACA,8BAAA;EACA,UAAA;AApCJ;;AAwCA;EACI,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,8BAAA;EACA,SAAA;AArCJ;;AAwCA;EACI,qBAAA;EACA,wBAAA;AArCJ;;AAwCA;EACI,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,+BAAA;EACA,UAAA;EACA,UAAA;AArCJ;;AAyCI;EACI,mBAAA;EACA,gBAAA;AAtCR;;AA0CA;EACI,SAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,gCAAA;EACA,UAAA;EACA,gBAAA;AAvCJ;AA2CQ;EACI,mBAAA;AAzCZ;;AA8CA;EACI,cAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AA3CJ;;AA8CA;EACI,mBAAA;EACA,iBAAA;AA3CJ;;AA8CA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,yBAAA;AA3CJ;AA6CI;EAEI,gCAAA;EACA,UAAA;EACA,WAAA;AA5CR;;AAgDA;EACI,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,uBAAA;AA7CJ;;AAgDA;EACI,oBAAA;AA7CJ;AA+CI;EACI,kBAAA;AA7CR;AAgDI;;;;;;;EAOI,aAAA;AA9CR;;AAkDA;EACI,oCAAA;AA/CJ;AAiDI;EACI,cAAA;AA/CR;AAkDI;;;;;;;EAOI,oCAAA;AAhDR;;AAoDA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAjDJ","sourcesContent":[".rdrCalendarWrapper {\n    color: #000000;\n    font-size: 12px;\n}\n\n.rdrDateDisplayWrapper {\n    background-color: rgb(239, 242, 247);\n}\n\n.rdrDateDisplay {\n    margin: 0.833em;\n}\n\n.rdrDateDisplayItem {\n    border-radius: 4px;\n    background-color: rgb(255, 255, 255);\n    box-shadow: 0 1px 2px 0 rgba(35, 57, 66, 0.21);\n    border: 1px solid transparent;\n\n    input {\n        cursor: pointer;\n        height: 2.5em;\n        line-height: 2.5em;\n        border: 0px;\n        background: transparent;\n        width: 100%;\n        color: #849095;\n    }\n}\n\n.rdrDateDisplayItemActive {\n    border-color: currentColor;\n}\n\n.rdrDateDisplayItemActive {\n    input {\n        color: #7d888d\n    }\n}\n\n.rdrMonthAndYearWrapper {\n    align-items: center;\n    padding-top: 19px;\n    padding-bottom: 15px;\n}\n\n.rdrMonthAndYearPickers {\n    font-weight: 600;\n\n    select {\n        appearance: none;\n        -webkit-appearance: none;\n        border: 0;\n        background: transparent;\n        padding-right: 30px;\n        outline: 0;\n        color: #3e484f;\n        background: url(\"data:image/svg+xml;utf8,<svg width='9px' height='6px' viewBox='0 0 9 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Artboard' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(-636.000000, -171.000000)' fill-opacity='0.368716033'><g id='input' transform='translate(172.000000, 37.000000)' fill='%230E242F' fill-rule='nonzero'><g id='Group-9' transform='translate(323.000000, 127.000000)'><path d='M142.280245,7.23952813 C141.987305,6.92353472 141.512432,6.92361662 141.219585,7.23971106 C140.926739,7.5558055 140.926815,8.06821394 141.219755,8.38420735 L145.498801,13 L149.780245,8.38162071 C150.073185,8.0656273 150.073261,7.55321886 149.780415,7.23712442 C149.487568,6.92102998 149.012695,6.92094808 148.719755,7.23694149 L145.498801,10.7113732 L142.280245,7.23952813 Z' id='arrow'></path></g></g></g></svg>\") no-repeat;\n        background-position: right 8px center;\n        cursor: pointer;\n        text-align: center;\n\n        &:hover {\n            background-color: rgba(0, 0, 0, 0.07);\n        }\n    }\n}\n\n.rdrMonthPicker,\n.rdrYearPicker {\n    margin: 0 5px\n}\n\n.rdrNextPrevButton {\n    width: 24px;\n    display: flex;\n    justify-content: center;\n    background: #ffffff;\n    border: 0;\n    position: absolute;\n}\n\n.rdrNextPrevButtonIconContainer {\n    height: 24px;\n}\n\n.rdrWeekDays {}\n\n.rdrMonth {\n    .rdrWeekDays {\n        padding: 0;\n    }\n}\n\n.rdrMonths.rdrMonthsVertical .rdrMonth:first-child .rdrMonthName {\n    display: none;\n}\n\n.rdrWeekDay {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 20px;\n    color: #253342;\n}\n\n.rdrWeekEnd {\n    opacity: 0.3;\n}\n\n.rdrDay {\n    background: transparent;\n    user-select: none;\n    border: 0;\n    padding: 0;\n    line-height: 30px;\n    height: 30px;\n    text-align: center;\n    color: #000000;\n\n    &:focus {\n        outline: 0;\n    }\n}\n\n.rdrStartEdge.rdrEndEdge {\n    .rdrStartEdgeTriangle {\n        color: transparent;\n    }\n\n    .rdrEndEdgeTriangle {\n        color: transparent;\n    }\n}\n\n.rdrDayWeekend {}\n\n.rdrDayNumber {\n    outline: 0;\n    font-weight: 400;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.rdrDayToday .rdrDayNumber span {\n    font-weight: 500;\n\n    &:after {\n        content: '';\n        position: absolute;\n        bottom: 4px;\n        left: 50%;\n        transform: translate(-50%, 0);\n        width: 18px;\n        height: 2px;\n        border-radius: 2px;\n        background: #116E5F;\n    }\n}\n\n.rdrDayToday:not(.rdrDayPassive) {\n\n    .rdrStartEdge,\n    .rdrEndEdge {\n        &~.rdrDayNumber span:after {\n            background: #fff;\n        }\n    }\n}\n\n.rdrDay:not(.rdrDayPassive) {\n\n    .rdrInRange,\n    .rdrStartEdge,\n    .rdrEndEdge,\n    .rdrSelected {\n        &~.rdrDayNumber {\n            span {\n                color: #000000;\n            }\n        }\n    }\n}\n\n.rdrSelected,\n.rdrInRange,\n.rdrStartEdge,\n.rdrEndEdge {\n    background: currentColor;\n    position: absolute;\n    top: 2px;\n    left: 0;\n    right: 0;\n    bottom: 2px;\n}\n\n.rdrSelected {\n    left: 2px;\n    right: 2px;\n}\n\n.rdrInRange {\n    background: #eef6f4;\n}\n\n.rdrStartEdge {\n    border-radius: 2px;\n    left: 2px;\n}\n\n.rdrStartEdgeTriangle {\n    position: absolute;\n    right: -4px;\n    top: 50%;\n    transform: translateY(-50%);\n    bottom: 0;\n    width: 0;\n    height: 0;\n    border-top: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n    border-left: 5px solid currentColor;\n    z-index: 1;\n}\n\n.rdrEndEdgeTriangle {\n    position: absolute;\n    left: -2px;\n    top: 50%;\n    color: #eef6f4;\n    transform: translateY(-50%);\n    bottom: 0;\n    width: 0;\n    height: 0;\n    border-top: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n    border-left: 5px solid currentColor;\n    z-index: 1;\n}\n\n.rdrEndEdge {\n    border-radius: 2px;\n    right: 2px;\n}\n\n.rdrSelected {\n    border-radius: 2px;\n}\n\n.rdrDayStartOfMonth,\n.rdrDayStartOfWeek {\n\n    .rdrInRange,\n    .rdrEndEdge {\n        border-top-left-radius: 2px;\n        border-bottom-left-radius: 2px;\n        left: 2px;\n    }\n}\n\n.rdrDayEndOfMonth,\n.rdrDayEndOfWeek {\n\n    .rdrInRange,\n    .rdrStartEdge {\n        border-top-right-radius: 2px;\n        border-bottom-right-radius: 2px;\n        right: 2px;\n    }\n}\n\n.rdrDayStartOfMonth,\n.rdrDayStartOfWeek {\n\n    .rdrDayInPreview,\n    .rdrDayEndPreview {\n        border-top-left-radius: 2px;\n        border-bottom-left-radius: 2px;\n        border-left-width: 1px;\n        left: 0px;\n    }\n}\n\n.rdrDayEndOfMonth,\n.rdrDayEndOfWeek {\n\n    .rdrDayInPreview,\n    .rdrDayStartPreview {\n        border-top-right-radius: 2px;\n        border-bottom-right-radius: 2px;\n        border-right-width: 1px;\n        right: 0px;\n    }\n}\n\n\n.rdrDayStartPreview,\n.rdrDayInPreview,\n.rdrDayEndPreview {\n    background: rgba(255, 255, 255, 0.09);\n    position: absolute;\n    top: 3px;\n    left: 0;\n    right: 0;\n    bottom: 3px;\n    pointer-events: none;\n    border: 0px solid currentColor;\n    z-index: 1;\n}\n\n\n.rdrDayStartPreview {\n    border-top-width: 1px;\n    border-left-width: 1px;\n    border-bottom-width: 1px;\n    border-top-left-radius: 2px;\n    border-bottom-left-radius: 2px;\n    left: 0px;\n}\n\n.rdrDayInPreview {\n    border-top-width: 1px;\n    border-bottom-width: 1px;\n}\n\n.rdrDayEndPreview {\n    border-top-width: 1px;\n    border-right-width: 1px;\n    border-bottom-width: 1px;\n    border-top-right-radius: 2px;\n    border-bottom-right-radius: 2px;\n    right: 2px;\n    right: 0px;\n}\n\n.rdrDefinedRangesWrapper {\n    .rdrStaticRangeSelected {\n        color: currentColor;\n        font-weight: 600;\n    }\n}\n\n.rdrStaticRange {\n    border: 0;\n    cursor: pointer;\n    display: block;\n    outline: 0;\n    border-bottom: 1px solid #eff2f7;\n    padding: 0;\n    background: #fff;\n\n    &:hover,\n    &:focus {\n        .rdrStaticRangeLabel {\n            background: #eff2f7;\n        }\n    }\n}\n\n.rdrStaticRangeLabel {\n    display: block;\n    outline: 0;\n    line-height: 18px;\n    padding: 10px 20px;\n    text-align: left;\n}\n\n.rdrInputRange {\n    align-items: center;\n    padding: 5px 20px;\n}\n\n.rdrInputRangeInput {\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    border-radius: 4px;\n    text-align: center;\n    border: solid 1px rgb(222, 231, 235);\n    margin-right: 10px;\n    color: rgb(108, 118, 122);\n\n    &:focus,\n    &:hover {\n        border-color: rgb(180, 191, 196);\n        outline: 0;\n        color: #333;\n    }\n}\n\n.rdrCalendarWrapper:not(.rdrDateRangeWrapper) .rdrDayHovered .rdrDayNumber:after {\n    content: '';\n    border: 1px solid currentColor;\n    border-radius: 2px;\n    background: transparent;\n}\n\n.rdrDayPassive {\n    pointer-events: none;\n\n    .rdrDayNumber span {\n        color: transparent;\n    }\n\n    .rdrInRange,\n    .rdrStartEdge,\n    .rdrEndEdge,\n    .rdrSelected,\n    .rdrDayStartPreview,\n    .rdrDayInPreview,\n    .rdrDayEndPreview {\n        display: none;\n    }\n}\n\n.rdrDayDisabled {\n    background-color: rgb(248, 248, 248);\n\n    .rdrDayNumber span {\n        color: #aeb9bf;\n    }\n\n    .rdrInRange,\n    .rdrStartEdge,\n    .rdrEndEdge,\n    .rdrSelected,\n    .rdrDayStartPreview,\n    .rdrDayInPreview,\n    .rdrDayEndPreview {\n        filter: grayscale(100%) opacity(60%);\n    }\n}\n\n.rdrMonthName {\n    font-size: 14px;\n    font-weight: 500;\n    color: #116E5F;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
